import React from 'react';

const getInitiales = (nom) => {
    if (!nom) return '??';
    const parts = nom.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '??';
    if (parts.length === 1) return (parts[0][0] ?? '?').toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ListeIntervenants = ({ intervenants }) => {
    const maxVisible = 5;
    const visibles = (intervenants ?? []).slice(0, maxVisible);
    const reste = (intervenants?.length ?? 0) - maxVisible;

    return (
        <div className="d-flex align-items-center">
            {visibles.map((intervenant) => (
                <div
                    key={intervenant.idIntervenant}
                    className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center shadow-sm"
                    style={{ width: '30px', height: '30px', marginLeft: -7, fontSize: 12, border: '1px solid white', flexShrink: 0 }}
                    title={intervenant.nom}
                >
                    {getInitiales(intervenant.nom)}
                </div>
            ))}

            {reste > 0 && (
                <div
                    className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center shadow-sm fw-semibold"
                    style={{ width: '30px', height: '30px', marginLeft: -7, fontSize: 12, border: '1px solid white', flexShrink: 0 }}
                    title={`${reste} de plus`}
                >
                    +{reste}
                </div>
            )}
        </div>
    );
};

export default ListeIntervenants;
